// extracted by mini-css-extract-plugin
module.exports = {"button":"button--2NU5E6iX"};